import { useAuthStore } from '@/store/auth'
import { useNotesStore } from '@/store/notes'

export default defineNuxtPlugin(() => {
  if (process.server) return
  const auth = useAuthStore()
  const notes = useNotesStore()

  let hydratedFromFirestore = false

  async function tryHydrateFromFirestore() {
    if (!auth.user?.uid && !auth.user?.email) return
    if (!notes.hydrated || hydratedFromFirestore) return
    await notes.hydrateFromFirestore(auth.user.uid || auth.user.email)
    hydratedFromFirestore = true
  }

  const stopAuth = watch(
    () => auth.hydrated,
    (val) => { if (val) tryHydrateFromFirestore() },
    { immediate: true }
  )
  const stopNotes = watch(
    () => notes.hydrated,
    (val) => { if (val) tryHydrateFromFirestore() },
    { immediate: true }
  )

  // Hydrate notes when user logs in
  watch(
    () => auth.user,
    async (user) => {
      if (user && (user.uid || user.email)) {
        await notes.hydrateFromFirestore(user.uid || user.email)
        hydratedFromFirestore = true
      } else {
        hydratedFromFirestore = false
      }
    }
  )
})
